import { Taxpayers, Partners, IIncomeReceipt } from '@/store/types';


export const statuses: Partial<Record<Taxpayers['status'], any>> = {
  // NEW: { label: 'Новый', color: 'GREEN' },
  ACTIVE: { label: 'Действующий', color: 'GREEN' },
  INACTIVE: { label: 'Недействующий', color: 'GRAY' },
  // DELETED: { label: 'Удаленный', color: 'GRAY' },
};

export const receiptStatuses: Partial<Record<IIncomeReceipt['status'], any>> = {
  NEW: { label: 'Активный', color: 'GREEN'},
  PROCESSED: { label: 'Активный', color: 'GREEN'},
  CANCELLATION: { label: 'Аннулированный', color: 'GRAY'},
  ERROR: { label: 'Аннулированный', color: 'GRAY'},
}

export const receiptFiltersStatuses= [
  {label: "Активный", value: "NEW,PROCESSED"},
  {label: "Аннулированный", value: "CANCELLATION"},
];

export const taxpayerTypes: Partial<Record<Taxpayers['type'], any>> = {
  FL: { label: 'ФЛ', fullName: 'Физическое лицо', color: 'BLUE' },
  IP: {
    label: 'ИП',
    fullName: 'Индивидуальный предприниматель',
    color: 'YELLOW',
  },
  UL: { label: 'ЮЛ', fullName: 'Юридическое лицо', color: 'PURPLE' },
};

export const partnerTypes: Partial<Record<Partners['type'], any>> = {
  INTERNET: 'Интернет',
  OFD: 'ОФД',
  BANK: 'Банк',
};

export const periodTypes = [
  { label: 'За день', value: 'date' },
  { label: 'За месяц', value: 'month' },
];

export const taxpayerJoinTypes: Partial<Record<Taxpayers['createType'], any>> =
  {
    SELF: { label: 'Самостоятельно' },
    PARTNER: { label: 'Партнер' },
  };
